import React from 'react';
import tpl from '../templates/main';
import BaseNewCardView from '../../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'mastercard'
        };
    }

    static displayName = 'P2PCrossborder.Views.Main';
}
